import { useScheduleContext } from "@/features/consultations/contexts";
import { AVAILABLE_LANGUAGE } from "@/shared/models";
import type { AvailableLanguage } from "@/shared/models";
import { RadioGroup } from "@/shared/ui";

export const ConsultationLanguagePreference = () => {
  const {
    language,
    actions: { setLanguage, setScheduleDate },
  } = useScheduleContext();

  const LANGUAGE_OPTIONS = [
    { value: AVAILABLE_LANGUAGE.EN, label: "English" },
    { value: AVAILABLE_LANGUAGE.ES, label: "Español" },
  ] as const;

  return (
    <RadioGroup.Root
      defaultValue={language}
      onValueChange={(lang) => {
        setLanguage(lang as AvailableLanguage);
        setScheduleDate((prev) => ({
          ...prev,
          appointmentDate: undefined,
          timeSlot: undefined,
        }));
      }}
      className="flex items-center gap-6 pl-6"
    >
      {LANGUAGE_OPTIONS.map(({ value, label }) => (
        <RadioGroup.Item key={value} value={value}>
          <RadioGroup.Label>{label}</RadioGroup.Label>
        </RadioGroup.Item>
      ))}
    </RadioGroup.Root>
  );
};
